import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { Maker } from '@root/entities/trade'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { TypeHelper } from '@blade/std-lib'
import type { ServicesMakerHoldersListParams } from '@blade/trade-api-client'
import type { PairAddress } from '@root/entities/pair'

interface FetchHoldersRequestActionParams
  extends TypeHelper.OmitKey<
    ServicesMakerHoldersListParams,
    'network' | 'pairAddress'
  > {
  pairAddress: PairAddress
  network: Network.Network
}

export const fetchHoldersRequestAction = action(
  async (ctx, { network, ...req }: FetchHoldersRequestActionParams) => {
    const {
      tradeApiClient,
      environment: {
        assets: { avatarsHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesMakerHoldersList, [
        {
          ...req,
          network: Network.toDto(network),
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) =>
        it.map((dto) => Maker.fromRankedDto(dto, avatarsHost)),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'fetchHoldersRequestAction',
)
